import { rem } from 'polished';
import styled from 'styled-components';

import { spacing } from '../../../../theme';
import { DataTableVariableNames } from '../../constants';

export const RowActionCellRoot = styled.td`
  position: sticky;
  right: 0;
  box-sizing: border-box;
  width: ${rem('52px')};
  padding-left: ${spacing['2x']};
`;

export const RowActionCellChildren = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: var(${DataTableVariableNames.BackgroundColor});
`;

export const RowActionHeaderCell = styled.th`
  box-sizing: border-box;
  background-color: transparent;
  pointer-events: none;
`;
